import { render } from "./WhatsAppIcon.vue?vue&type=template&id=77484f5a&scoped=true"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=77484f5a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77484f5a"]])

export default __exports__